module.exports = __webpack_public_path__ + "static/media/TeamWorkDena01.f4bf21c3.png";